<template>
  <b-form>
    <!-- TRANSPORTES -->
    <b-form-row>
      <b-card header="Naciones Unidas" class="col-12">
        <b-row class="float-right mt-0">
          <b-col sm="4">
            <b-button
              type="button"
              size="sm"
              class="mb-2"
              style="width: 200px !important;"
              variant="primary"
              @click="crearTransporte()"
            >
              Crear transporte
            </b-button>
          </b-col>
        </b-row>
        <!-- TABLA DE TRANSPORTES -->
        <b-table responsive
                 small
                 thead-class="table-active"
                 :items="naciones_unidas"
                 :fields="columnas" >
          <template v-slot:cell(tipo_transporte)="row">
            {{ row.item.transporteLista.lista }}
          </template>
          <template v-slot:cell(noun)="row">
            {{ row.item.noun }}
          </template>
          <template v-slot:cell(riesgo_principal)="row">
            {{ row.item.riesgoPrincipal.codigo }} {{ row.item.riesgoPrincipal.descripcion }}
          </template>
          <template v-slot:cell(riesgo_secundario)="row">
            {{ row.item.riesgoSecundario.codigo }} {{ row.item.riesgoSecundario.descripcion }}
          </template>
          <template v-slot:cell(riesgo_secundario1)="row">
            {{ row.item.riesgoSecundario1.codigo }} {{ row.item.riesgoSecundario1.descripcion }}
          </template>
          <template v-slot:cell(action)="row">
            <el-tooltip
              content="Editar Componente"
              placement="top"
              effect="light"
            >
              <b-button
                size="sm"
                class="mr-1 mt-1"
                variant="primary"
                @click.prevent="editarTransporte(row.item)"
              ><i class="el-icon-edit"></i
              ></b-button>
            </el-tooltip>
            <el-tooltip
              content="Eliminar Componente"
              placement="top"
              effect="light"
            >
              <b-button
                size="sm"
                class="mr-1 mt-1"
                variant="danger"
                @click.prevent="eliminarTransporte(row.item)"
              ><i class="el-icon-delete"></i
              ></b-button>
            </el-tooltip>
          </template>
        </b-table>
      </b-card>
    </b-form-row>

    <!-- Modal UN -->
    <b-modal id="transporte-fds-modal"
             v-model="transporte_fds_modal"
             :title="(selectedTransporte.accion === 'crear' ? 'Crear' : 'Editar') + ' Transporte'"
             size="lg"
    >
      <ModalFormTransportes />

      <template #modal-footer="{ ok, cancel, hide }">
        <b-button size="sm" variant="primary" @click="guardarTransporte()">
          Guardar
        </b-button>
        <b-button size="sm" variant="danger" @click="cancel()">
          Cancelar
        </b-button>
      </template>
    </b-modal>

    <hr>
    <FooterButtons back="/fds/listar" />
  </b-form>
</template>

<script>
import Swal from 'sweetalert2';
import {mapActions, mapMutations, mapState} from 'vuex';
import FooterButtons from '../../componentes/FooterButtons';
import ModalFormTransportes from './ModalFormTransportes';
import {getTransportesDetalle} from "@/servicios/fds/productos/actions";

export default {
  name: "FDS-Seccion14",
  components: {
    ModalFormTransportes,
    FooterButtons,
  },
  data() {
    return {
      transporte_fds_modal: false,
      columnas: [
        {
          key: "tipo_transporte",
          label: "Medio de transporte",
          thStyle: {
            "min-width": "150px !important",
            width: "150px !important",
          },
        },
        {
          key: "riesgo_principal",
          label: "Riesgo Principal",
          thStyle: {
            "min-width": "120px !important",
            width: "120px !important",
          },
        },
        {
          key: "riesgo_secundario",
          label: "Riesgo Secundario",
          thStyle: {
            "min-width": "100px !important",
            width: "100px !important",
          },
        },
        {
          key: "riesgo_secundario1",
          label: "Riesgo Secundario 1",
          thStyle: {
            "min-width": "100px !important",
            width: "100px !important",
          },
        },
        {
          key: "action",
          label: "",
          thStyle: {
            "min-width": "80px !important",
            width: "80px !important",
          },
        },
      ],
      configTiny: {
        plugins: 'wordcount paste lists advlist',
        language_url: '/js/tiny_lang_es.js',
        height: '200px',
        content_style: 'body { font-family: Arial; user-select: none;}',
        contextmenu: 'undo redo | inserttable | cell row column deletetable | help',
        max_height: 500,
        entity_encoding : "raw",
        menubar: false,
        toolbar: `undo redo | paste | formatselect | bold italic underline | alignleft aligncenter alignright alignjustify |
                  bullist numlist outdent indent | removeformat`
      },
    }
  },
  async created() {
    await this.setSeccionActual(14);
    let id_empresa = await this.obtenerIdEmpresaUsuario();
    await this.setIdEmpresaFdsProducto(id_empresa);
    if (this.$route.params.id_fds_producto !== undefined) {
      let id_fds_producto = this.$route.params.id_fds_producto;
      let data = {
        id_empresa: id_empresa,
        id_fds_producto: id_fds_producto,
      };
      await this.getSeccion(data);
      await this.setIdFdsProductoSeccion(id_fds_producto);
      await this.getTransportesDetalle();
    } else {
      await this.resetSeccion();
    }
  },
  methods: {
    async guardar() {
      if (this.accion === 'crear') {
        await this.crearSeccion();
      } else if (this.accion === 'editar'){
        await this.actualizarSeccion();
      }
    },
    async crearTransporte() {
      await this.resetSelectedTransporte();
      this.transporte_fds_modal = true;
    },
    async guardarTransporte() {
      if (this.selectedTransporte.accion === 'crear') {
        await this.crearTransporteDetalle();
      } else if (this.selectedTransporte.accion === 'editar') {
        await this.actualizarTransporteDetalle();
      }
      this.transporte_fds_modal = false;
    },
    async editarTransporte(item) {
      await this.resetSelectedTransporte();
      await this.setSelectedTransporte(item);
      this.transporte_fds_modal = true;
    },
    eliminarTransporte(item) {
      let confirm = false;
      Swal.fire({
        text: "¿Desea eliminar el transporte de naciones unidas?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#097b83',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.borrarTransporteDetalle(item);
        }
      });
    },
    ...mapMutations('fds_productos', [
      'setSeccionActual',
      'setIdFdsProductoSeccion',
      'resetSelectedTransporte'
    ]),
    ...mapActions('dashboard', [
      'obtenerIdEmpresaUsuario',
    ]),
    ...mapActions('fds_productos', [
      'getSeccion',
      'crearSeccion',
      'actualizarSeccion',
      'getTransportesDetalle',
      'crearTransporteDetalle',
      'actualizarTransporteDetalle',
      'borrarTransporteDetalle'
    ]),
    ...mapMutations('fds_productos',[
      'setIdEmpresaFdsProducto',
      'setSeccionActual',
      'resetSeccion',
      'setSelectedTransporte'
    ]),
  },
  computed: {
    ...mapState('fds_productos',[
      'id_empresa',
      'accion',
      'selectedSeccion14',
      'naciones_unidas',
      'selectedTransporte'
    ])
  }
}
</script>
